import {batch} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants"
import { commonFiltersValue } from "@signals"
import {isLoadingShareOfSearch, isShareOfSearchEmpty, dataShareOfSearch} from "../@signals";


export default function useShareOfSearchShareOfSearch() {
	const callShareOfSearchData = () => batch(() => {
		isLoadingShareOfSearch.value = true
		isShareOfSearchEmpty.value = false
		// **Same endpoint as Digital Shelf › Overview**, on dipi-webback-v2 since 2026-08-12: v1
		// serves both screens from `digital-shelf/context`. Migrated together for that reason —
		// leaving this one on v1 would have the two screens reading different backends.
		return postSubmit(`${WEBBACK_V2_API}/digital-shelf/context`, commonFiltersValue.value).then(res => {
			dataShareOfSearch.value = res
		}).finally(() => isLoadingShareOfSearch.value = false)
	})

	return {
		callShareOfSearchData
	}
}